import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

/**
 * 수입·지출 균형 카드 컴포넌트
 * 지출비율, 저축률, 수입안정성 3개 지표를 시각적으로 표시한다.
 *
 * @param {Object} props
 * @param {Object} props.balanceMetrics - useInsightsData에서 반환된 balanceMetrics
 * @param {Object} props.balanceMetrics.expenseRatio - 지출비율 지표
 * @param {Object} props.balanceMetrics.savingsRate - 저축률 지표
 * @param {Object} props.balanceMetrics.incomeStability - 수입안정성 지표
 */
const BalanceCard = ({ balanceMetrics }) => {
  const { expenseRatio, savingsRate, incomeStability } = balanceMetrics;

  const metrics = [
    { label: '지출비율', iconName: 'account_balance_wallet', ...expenseRatio, unit: '%' },
    { label: '저축률', iconName: 'savings', ...savingsRate, unit: '%' },
    {
      label: '수입안정성',
      iconName: 'show_chart',
      ...incomeStability,
      unit: incomeStability.value === '-' ? '' : '%',
    },
  ];

  return (
    <div className="insights-card insights-balance-card">
      <h3 className="insights-card__title">수입·지출 균형</h3>
      <div className="insights-balance-grid">
        {metrics.map((metric) => (
          <div key={metric.label} className="insights-balance-item" tabIndex={0}>
            <span className="insights-balance-item__icon">
              <Icon name={metric.iconName} size={24} />
            </span>
            <span className="insights-balance-item__label">{metric.label}</span>
            <span className="insights-balance-item__value">
              {metric.value}
              {metric.unit}
            </span>
            <span className={`insights-balance-item__status ${metric.colorClass}`}>
              {metric.status}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

BalanceCard.propTypes = {
  balanceMetrics: PropTypes.shape({
    expenseRatio: PropTypes.object.isRequired,
    savingsRate: PropTypes.object.isRequired,
    incomeStability: PropTypes.object.isRequired,
  }).isRequired,
};

export default BalanceCard;
